import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "ElementMetaField";
var classes = {
    thesaurus: "".concat(PREFIX, "-thesaurus"),
    clamping: "".concat(PREFIX, "-clamping"),
    firstLetterUpper: "".concat(PREFIX, "-firstLetterUpper"),
    ellipsis: "".concat(PREFIX, "-ellipsis")
};
var StyledElementMetaField = styled(Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["& .".concat(classes.thesaurus)] = {
            display: "flex",
            flexWrap: "wrap",
            gap: theme.spacing(0.4),
            "& .MuiChip-root": {
                borderRadius: "15px"
            }
        },
        _b["& .".concat(classes.clamping)] = {
            // TODO: will work only on webkit, find a more general clamping solution
            // Not critic, nice to have the title on two line
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflowWrap: "break-word"
        },
        _b["& .".concat(classes.firstLetterUpper)] = {
            display: "inline-block",
            textTransform: "lowercase",
            "&:first-letter": {
                textTransform: "uppercase"
            }
        },
        /**
         * Apply ellipsis to descendant paragraph tag used for multi-line content (text area for example)
         */
        _b["& .".concat(classes.ellipsis)] = {
            "& > div": {
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis"
            }
        },
        _b);
});

export { classes, StyledElementMetaField as default };
//# sourceMappingURL=index.styled.js.map
